/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { Switch } from '@/utils/switch';
import { SxProps, Theme } from '@mui/material';

export const alertSX = (severity: string): SxProps<Theme> => ({
	'.MuiAlert-message': {
		whiteSpace: 'normal',
		overflowWrap: 'break-word',
		wordWrap: 'break-word',
		wordBreak: 'break-word',
	},
	backgroundColor: Switch(severity)
		.case('info', () => '#F3F1F6')
		.case('success', () => '#ECF3E7')
		.defaultTo(() => undefined),
	boxShadow: '1px 1px 1px 1px rgba(0, 0, 0, 0.2)',
	color: Switch(severity)
		.case('info', () => '#774A91')
		.case('success', () => '#31942B')
		.defaultTo(() => undefined),
});
